import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux'
import { isWindows, isMacOs } from 'react-device-detect'
import { v4 as uuidv4 } from 'uuid';

import { Modal, Button } from 'components'
import { BiCommand } from 'react-icons/bi'
import { FaTimes } from 'react-icons/fa'
import * as actionCreators from 'store/actions';

const defaultStyle = {
    padding: '1rem',
    backgroundColor: 'var(--primary-color)',
    secondaryColor: 'var(--secondary-color)',
    border: '1px solid var(--secondary-color)'
}

const Container = styled.div`
    width: 20rem;
    padding: ${props => props.styles.padding};
    border-radius: 5px;
    background-color: ${props => props.styles.backgroundColor};
    box-shadow: var(--box-shadow);
    border: ${props => props.styles.border};
`

const Wrapper = styled.div`
    width: 100%;
    padding: ${props => props.styles.padding};
    background-color: ${props => props.styles.backgroundColor};
`

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const Title = styled.div`
    font-weight: bold;
    font-size: 1rem;
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.8rem;
`

const Row = styled.div`
    display: grid;
    grid-template-columns: 50% 50%;
    justify-items: start;
    align-items: center;
    background-color: ${props => props.styles.secondaryColor};
    grid-column-gap: 2px;
    background-color: ${props => props.styles.backgroundColor};
`

const Command = styled.div`
    background-color: ${props => props.styles.backgroundColor};
    width: 100%;
    /* height: 100%; */
    display: flex;
    align-items: center;
    justify-content: flex-start;
`

const CommandTagContainer = styled.div`
    width: 100%;
    /* height: 100%; */
    display: flex;
    background-color: ${props => props.styles.backgroundColor};
    padding-left: 0.5rem;
`

const CommandTag = styled.div`
    border-radius: 5px;
    background-color: ${props => props.styles.secondaryColor};
    min-width: 1.5rem;
    min-height: 1.5rem;
    padding: 0.3rem;
    margin: 0.2rem 0.4rem 0.2rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: var(--box-shadow);
`

const commonShortcuts = {
    // 'Shortcuts': ['shift', '?'],
    'Support': ['shift', '?'],
    'Command bar': ['command', 'p'],
    'Modules': ['command', 'b'],
    'Side menu': ['command', 'm'],
    'New item': ['\\'],

    'Toggle page view': ['command', '\\'],
    'Toggle full width': ['command', 'shift', '\\'],
    'Toggle divider': ['command', 'd'],
    'Undo': ['command', 'z'],
    'Redo': ['command', 'shift', 'z'],

    'Increase indent': ['tab'],
    'Decrease indent': ['shift', 'tab']
}

const ShortcutsModal = props => {
    const { inline, styles } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    const dispatch = useDispatch();

    const onClose = () => {
        dispatch(actionCreators.setModal(null,null))
    }

    let blocks = []
    for (const [key, commands] of Object.entries(commonShortcuts)) {
        blocks.push(
            <Row styles={updatedStyle}>
                <Command styles={updatedStyle}>{key}</Command>
                <CommandTagContainer styles={updatedStyle}>
                    {commands.map(command => {
                        if(command === 'command' & isMacOs){
                            return <CommandTag styles={updatedStyle}><BiCommand size='12'/></CommandTag>
                        } else if (command === 'command') {
                            return <CommandTag styles={updatedStyle}>Ctrl</CommandTag>
                        } else if (['shift','tab','enter']) {
                            return <CommandTag styles={updatedStyle}>{command.charAt(0).toUpperCase() + command.slice(1)}</CommandTag>
                        } else {
                            return <CommandTag styles={updatedStyle}>{command.toUpperCase()}</CommandTag>
                        }
                    })}
                </CommandTagContainer>
                
            </Row>
        )
    }
    if(inline){
        return (
            <Wrapper styles={updatedStyle}>
                <Column>{blocks}</Column>
            </Wrapper>
        )
    } else {
        return(
            <Modal>
                <Container styles={updatedStyle}>
                    <Header styles={updatedStyle}>
                        <Title styles={updatedStyle}>Shortcuts</Title>
                        <Button onSelect={onClose} icon={<FaTimes/>} styles={{ padding: '0.5rem', backgroundColor: 'var(--primary-color)', boxShadowColor: 'transparent', margin: 0 }}/>
                    </Header>
                    <Column>{blocks}</Column>
                </Container>
            </Modal>
        )
    }
    
}

export default ShortcutsModal